import React from "react";
import PropTypes from 'prop-types';
import TruncateText from './TruncateText';

import './contentTitle.less';

const ContentTitle = (props) => {
    return (
        <div className="content-title">
            <TruncateText line={props.numLines} text={props.children} title={props.children} />
        </div>
    );
}

ContentTitle.defaultProps = {
    numLines: 2
};

ContentTitle.propTypes = {
    numLines: PropTypes.number
};

export default ContentTitle;


// WEBPACK FOOTER //
// ./src/react/views/generic/ContentTitle.jsx